/**
 * Outcome of a single form-data lookup, so a deliberate skip and a failed request are distinguishable
 * at the call site.
 */
export enum FormsFetchStatus {
    /** The answer is known. Empty `data` means nothing is required, not that the set is unknown. */
    RESOLVED = 'resolved',
    /** Not requested: an input the API requires was absent, so the call could only be rejected. */
    SKIPPED = 'skipped',
    /** Requested and rejected. The required set is unknown. */
    FAILED = 'failed',
}

/** Inputs the form-data API requires. Sending a request without one of these earns a `400`. */
export enum FormsSkipReason {
    /**
     * No Prismic mapping (`key: "unset"`). No request could narrow the set and the defined answer is all
     * of the professional's forms — an answer, not a gap.
     */
    UNSET_APPOINTMENT_TYPE = 'unset_appointment_type',
    /** A PMS schedule with no patient attached. */
    NO_PATIENT = 'no_patient',
    /** No Versicherungsart on the appointment; the API accepts only `InsuranceType` members. */
    NO_INSURANCE_TYPE = 'no_insurance_type',
    /** No service on the appointment, so there are no `appointment_type_keys` to send. */
    NO_SERVICE_TYPE = 'no_service_type',
}

export type FormsFetch<T> =
    | { status: FormsFetchStatus.RESOLVED; data: T }
    | { status: FormsFetchStatus.SKIPPED; reason: FormsSkipReason }
    | { status: FormsFetchStatus.FAILED; http_status: number };

/** Whether a card can state its form requirements. */
export enum FormsResolution {
    RESOLVED = 'resolved',
    UNRESOLVED = 'unresolved',
    LOADING = 'loading',
    /** No patient attached, so the slot has no form requirement to state. */
    NOT_APPLICABLE = 'not_applicable',
}
